import { Todo } from '../types/data';
import { formatTokyoDate, getTodayTokyoDateString } from '../utils/dateUtils';

export const todoData: Todo[] = [
  {
    id: '1',
    title: 'プロジェクトの企画書作成',
    body: '新しいWebアプリの企画書を作成する',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-12T14:00:00Z',
    createdAt: '2025-07-12T09:00:00Z',
    modifiedAt: '2025-07-12T09:00:00Z',
    todoTagIds: ['tag-1', 'tag-2']
  },
  {
    id: '2',
    title: 'UI設計の見直し',
    body: 'ユーザビリティを向上させるための設計変更',
    done: true,
    canceled: false,
    deleted: false,
    startAt: '2025-07-12T16:30:00Z',
    doneAt: '2025-07-12T15:45:00Z',
    createdAt: '2025-07-12T10:30:00Z',
    modifiedAt: '2025-07-12T10:30:00Z'
  },
  {
    id: '3',
    title: 'データベース設計',
    body: 'Supabaseのテーブル設計を完成させる',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-13T18:00:00Z',
    createdAt: '2025-07-12T14:00:00Z',
    modifiedAt: '2025-07-12T14:00:00Z',
    todoTagIds: ['tag-1', 'tag-3']
  },
  {
    id: '4',
    title: 'チームミーティング',
    body: '週次進捗確認ミーティング',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-14T10:00:00Z',
    createdAt: '2025-07-12T16:00:00Z',
    modifiedAt: '2025-07-12T16:00:00Z'
  },
  {
    id: '5',
    title: 'コードレビュー',
    body: 'プルリクエストのレビューを実施',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-15T15:30:00Z',
    createdAt: '2025-07-12T11:00:00Z',
    modifiedAt: '2025-07-12T11:00:00Z'
  },
  {
    id: '6',
    title: 'ドキュメント更新',
    body: 'APIドキュメントの更新作業',
    done: true,
    canceled: false,
    deleted: false,
    startAt: '2025-07-11T17:00:00Z',
    doneAt: '2025-07-11T16:45:00Z',
    createdAt: '2025-07-11T15:30:00Z',
    modifiedAt: '2025-07-11T15:30:00Z'
  },
  {
    id: '7',
    title: 'バグ修正',
    body: 'ログイン機能のバグを修正',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-16T12:00:00Z',
    createdAt: '2025-07-12T13:00:00Z',
    modifiedAt: '2025-07-12T13:00:00Z'
  },
  {
    id: '8',
    title: '期限切れタスク',
    body: '昨日までに完了予定だったタスク',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-10T09:00:00Z',
    createdAt: '2025-07-10T10:00:00Z',
    modifiedAt: '2025-07-10T10:00:00Z'
  },
  {
    id: '9',
    title: '期限切れタスク2',
    body: '先週完了予定だったタスク',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-09T14:00:00Z',
    createdAt: '2025-07-09T14:00:00Z',
    modifiedAt: '2025-07-09T14:00:00Z'
  },
  {
    id: '10',
    title: '期限切れタスク3',
    body: '先週完了予定だったタスク',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-09T16:30:00Z',
    createdAt: '2025-07-09T14:00:00Z',
    modifiedAt: '2025-07-09T14:00:00Z'
  },
  {
    id: '11',
    title: '期限切れタスク4',
    body: '先週完了予定だったタスク',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-09T11:15:00Z',
    createdAt: '2025-07-09T14:00:00Z',
    modifiedAt: '2025-07-09T14:00:00Z'
  },
  {
    id: '12',
    title: '期限切れタスク5',
    body: '先週完了予定だったタスク',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-09T13:45:00Z',
    createdAt: '2025-07-09T14:00:00Z',
    modifiedAt: '2025-07-09T14:00:00Z'
  },
  {
    id: '13',
    title: '新しいタスク',
    body: '今日のタスク',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-20T13:45:00Z',
    createdAt: '2025-07-09T14:00:00Z',
    modifiedAt: '2025-07-09T14:00:00Z'
  },
  {
    id: '14',
    title: '新しいタスク',
    body: '明日のタスク',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-21T09:45:00Z',
    createdAt: '2025-07-09T14:00:00Z',
    modifiedAt: '2025-07-09T14:00:00Z'
  },
  {
    id: '15',
    title: '新しいタスク（期限切れ）',
    body: '今日のタスク（期限切れのテスト用）',
    done: false,
    canceled: false,
    deleted: false,
    startAt: '2025-07-21T02:00:00Z',
    createdAt: '2025-07-09T14:00:00Z',
    modifiedAt: '2025-07-09T14:00:00Z'
  }
];

// 絶対時刻を日本時間の日付文字列に変換するヘルパー関数
export const getLocalDateString = (utcDateString: string): string => {
  return formatTokyoDate(utcDateString);
};

// 指定した日付が今日より前かどうかを判定する関数
const isPastDate = (date: string): boolean => {
  return date < getTodayTokyoDateString();
};

// 指定した日付のTODOを取得する関数（現地時間ベース）
export const getTodosByDate = (date: string): Todo[] => {
  return todoData.filter(todo => {
    const todoLocalDate = getLocalDateString(todo.startAt);
    return todoLocalDate === date;
  });
};

// TODOが存在する日付の一覧を取得する関数（現地時間ベース）
export const getDatesWithTodos = (): string[] => {
  const dates = todoData.map(todo => {
    return getLocalDateString(todo.startAt);
  });
  const uniqueDates = Array.from(new Set(dates));
  return uniqueDates.sort();
};

// 期限切れTODOが存在する日付の一覧を取得する関数（現地時間ベース）

// 指定した日付のTODOバッジ状態を取得する関数
export interface TodoBadgeStatus {
  hasTodo: boolean;
  hasExpiredTodo: boolean;
}

// 単一Todoが期限切れか判定（未完了かつ startAt < now）
export const isTodoExpired = (todo: Todo, now: Date = new Date()): boolean => {
  if (todo.done) return false;
  if (todo.canceled) return false;
  const startAt = new Date(todo.startAt);
  return startAt.getTime() < now.getTime();
};

// 入力されたtodos配列に対して、指定した日付のバッジ状態を算出
export const getTodoBadgeStatusFromTodos = (
  date: string,
  todos: Todo[],
  now: Date = new Date()
): TodoBadgeStatus => {
  const todosForDate = todos.filter(todo => {
    const todoLocalDate = getLocalDateString(todo.startAt);
    return todoLocalDate === date && !todo.deleted;
  });

  const hasTodo = todosForDate.length > 0;

  const todayString = formatTokyoDate(now);
  const isTodayDate = date === todayString;

  const hasExpiredTodo = todosForDate.some(todo => {
    if (todo.done) return false;
    if (todo.canceled) return false;
    if (isPastDate(date)) return true; // 過去日は常に期限切れ
    if (isTodayDate) {
      const startAt = new Date(todo.startAt);
      return startAt.getTime() < now.getTime();
    }
    return false;
  });

  return { hasTodo, hasExpiredTodo };
};

export const getTodoBadgeStatus = (date: string): TodoBadgeStatus => {
  // 既存のスタティックデータに対しても、同一ロジックを適用
  return getTodoBadgeStatusFromTodos(date, todoData);
};

// 期限切れTODOが存在する日付の一覧（現地時間ベース）を、
// 「今日の時刻超過」も含めて判定するよう更新
export const getDatesWithExpiredTodos = (): string[] => {
  const dates = Array.from(new Set(todoData.map(todo => getLocalDateString(todo.startAt))));
  const now = new Date();
  const expiredDates = dates.filter(date => getTodoBadgeStatusFromTodos(date, todoData, now).hasExpiredTodo);
  return expiredDates.sort();
};
